import { render, staticRenderFns } from "./SingleSQ.vue?vue&type=template&id=7a015945&scoped=true&"
import script from "./SingleSQ.vue?vue&type=script&lang=js&"
export * from "./SingleSQ.vue?vue&type=script&lang=js&"
import style0 from "./SingleSQ.vue?vue&type=style&index=0&id=7a015945&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a015945",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCardText,VDialog})
